export enum TraineeType {
  PILOT = 'PILOT',
  CABIN_CREW = 'CABIN_CREW',
  CADET = 'CADET',
  MAINTENANCE = 'MAINTENANCE',
  DRY_INSTRUCTOR = 'DRY_INSTRUCTOR',
  OTHER = 'OTHER',
  UNDEFINED = 'UNDEFINED'
}
